/**
 * copy.js — Hero section content constants.
 *
 * All user-facing strings for the Hero component live here.
 * When the EP releases, update HERO_EYEBROW with the actual date
 * and fill in HERO_QUOTES if new press blurbs come in.
 */

export const HERO_BAND_NAME = 'Joytrip';

export const HERO_EYEBROW = 'LEAVING STATE / LATEST EP / LISTEN NOW';

export const HERO_QUOTES = [
  'A feeling of restlessness and yearning cuts through their contemplative but sunny second EP. The beginning of each track feels like it\'s bursting onto the scene, awakening and wiping the sleep out of the disrupted silence, elevating the listener to a sense of hyper-aware clarity.',
  'Offering the ambience of chirping birds and rustling leaves. Buttery, reverbed guitar takes over, oozing, melting and slathering onto the senses. There\'s a sense of blissful contentedness, but that nagging yearning lingers in the outro.',
];

export const HERO_CTA_LABEL = 'Listen Now';

export const HERO_CTA_SPOTIFY_URL = 'https://open.spotify.com/album/1sfVxRscd5XCQuH2gqCFlR?si=1nalpowSQ3CjozoC9MZp_Q';
